export default `float s=3., e;
    s*=e=3./min(dot(p,p),50.);
    p=abs(p)*e;
    for(int i=0;i++<5;)
      p=vec3(8.0,4.0,2.0)-abs(p-vec3(8.0,4.0,2.0)),
      s*=e=8./min(dot(p,p),9.),
      p=abs(p)*e;
    return min(length(p.xz)-.1,p.y)/s;
  }`